const color = (value, fallback) =>
  /^#[a-f0-9]{6}$/i.test(value) ? value : fallback;
const number = (value, fallback, min, max) =>
  Number.isFinite(Number(value)) &&
  value !== undefined &&
  value !== null &&
  value !== ""
    ? Math.min(max, Math.max(min, Math.round(Number(value))))
    : fallback;
export function normalizeNavigationTabStyle(value) {
  return {
    variant: value?.variant === "pill" ? "pill" : "underline",
    color: color(value?.color, "#d4d4d8"),
    activeColor: color(value?.activeColor, "#ffffff"),
    indicatorColor: color(value?.indicatorColor, ""),
    fontSize: number(value?.fontSize, 16, 10, 28),
    gap: number(value?.gap, 28, 0, 48),
  };
}
